import { useContext } from 'react';
import { GridContentsColumnContext, useRegisterGridContentsColumnRow } from './GridContentsColumnContext';
import classNames from 'classnames';

export const GridContentsColumnItem = ({ className, style, children, onRowRegistration, rowName }) => {
  const {
    columnIndex,
    itemsClassName
  } = useContext(GridContentsColumnContext);
  const row = useRegisterGridContentsColumnRow(rowName);

  if (onRowRegistration) {
    onRowRegistration(row);
  }

  return (
    <>
      <div
        className={classNames(
          'gridContentsColumnItem',
          itemsClassName,
          className
        )}
        style={{
          gridColumn: columnIndex,
          gridRow: row,
          ...(style ?? {})
        }}
      >
        { children }
      </div>
    </>
  );
};
